// Converts an internal HEXA address (user@hexawebos.com) into a short
// "@username" handle for display. External addresses are returned as-is.
export function toHandle(address) {
  if (!address) return "";
  return address.endsWith("@hexawebos.com") ? `@${address.split("@")[0]}` : address;
}
